import isGHMC, { getCurrentDate } from "../../../../Common/helper/helpar";
import { Formik, Form, Field } from "formik";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import frequencyBinsGVPStore from "./store/frequencyBinsGVPStore";
import { FrequencyBinsExport } from "./FrequencyBinsExport";

export const FrequencyBinsFilter = () => {
  const isProd = isGHMC();
  const currentDate = getCurrentDate(); // YYYY-MM-DD

  const { fetchFrequencyBinsGVPOuterReport, frequencyBinsGVPData } =
    frequencyBinsGVPStore();
  const location = useLocation();

  // Initial filter values
  const initialFilterValues = {
    FromDate: currentDate,
    ToDate: currentDate,
  };

  // Get filters from location.state > localStorage > default
  const [defaultFilters, setDefaultFilters] = useState(() => {
    const passedFilters = location.state?.filters;
    const storedFilters = localStorage.getItem("frequencyBinsFilters");
    const parsedStored = storedFilters ? JSON.parse(storedFilters) : null;
    return passedFilters || parsedStored || initialFilterValues;
  });

  const handleSubmit = (values) => {
    localStorage.setItem("frequencyBinsFilters", JSON.stringify(values));
    fetchFrequencyBinsGVPOuterReport(values);
    setDefaultFilters(values);
  };

  const handleReset = (resetForm) => {
    resetForm();
    fetchFrequencyBinsGVPOuterReport(initialFilterValues);
    setDefaultFilters(initialFilterValues);
    localStorage.setItem("frequencyBinsFilters", JSON.stringify(initialFilterValues));
  };

  useEffect(() => {
    fetchFrequencyBinsGVPOuterReport(defaultFilters);
    localStorage.setItem("frequencyBinsFilters", JSON.stringify(defaultFilters));
  }, []);

  return (
    <Formik initialValues={defaultFilters} enableReinitialize onSubmit={handleSubmit}>
      {({ resetForm, values }) => (
        <Form>
          <div className="d-flex justify-content-between align-items-center mt-3">
            <div className="d-flex align-items-end gap-2 mb-2">
              <div style={{ width: "200px" }}>
                <div className="form-group-filter">
                  <label className="form-label w-100 text-left">From Date</label>
                  <Field
                    type="date"
                    id="FromDate"
                    name="FromDate"
                    className="form-control bg-white"
                    max={currentDate} // FromDate cannot be after today
                    required
                  />
                </div>
              </div>

              <div style={{ width: "200px" }}>
                <div className="form-group-filter">
                  <label className="form-label w-100 text-left">To Date</label>
                  <Field
                    type="date"
                    id="ToDate"
                    name="ToDate"
                    className="form-control bg-white"
                    min={values.FromDate} // ToDate cannot be before FromDate
                    max={currentDate} // ToDate cannot be after today
                    required
                  />
                </div>
              </div>

              <button
                type="submit"
                className={`btn w-90 ${isProd ? "search-ghmc" : "search-swm"}`}
              >
                Search
              </button>
              <button
                type="reset"
                className={`btn w-90 ${isProd ? "search-ghmc" : "search-swm"}`}
                onClick={() => handleReset(resetForm)}
              >
                Reset
              </button>
            </div>

            <div className="mt-4 d-flex">
              <FrequencyBinsExport
                data={frequencyBinsGVPData}
                fromDate={defaultFilters.FromDate}
                toDate={defaultFilters.ToDate}
              />
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};
